import React, { FC } from 'react';
import Form from 'components/Form';

import { EasyoffPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Easyoff: FC<EasyoffPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Easyoff;
